<template>
  <div class="mod-config">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.accpTxno" placeholder="支付交易流水号" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.txnSeqno" placeholder="商户交易流水号" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.applyId" placeholder="提现单号" clearable>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.payChannelId" placeholder="支付渠道" clearable>
          <el-option 
            v-for="item in payChannelOptions" 
            :key="item.value" 
            :label="item.label" 
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.status" placeholder="交易状态" clearable>
          <el-option 
            v-for="item in statusOptions" 
            :key="item.value" 
            :label="item.label" 
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="交易创建日期"
                    end-placeholder="交易结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="主键id">
      </el-table-column>
      <el-table-column
        prop="applyId"
        header-align="center"
        align="center"
        label="提现单号">
      </el-table-column>
      <el-table-column
        prop="txnSeqno"
        header-align="center"
        align="center"
        label="商户交易流水号">
      </el-table-column>
      <el-table-column
        prop="accpTxno"
        header-align="center"
        align="center"
        label="支付交易流水号">
      </el-table-column>
      <el-table-column
        prop="withdrawalAccount"
        header-align="center"
        align="center"
        label="提现账号">
      </el-table-column>
      <el-table-column
        prop="withdrawalAmount"
        header-align="center"
        align="center"
        label="提现金额 ">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="提现状态">
        <template slot-scope="scope">
          {{ getLabelByValue(statusOptions, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="tradingTime"
        header-align="center"
        align="center"
        label="交易时间">
      </el-table-column>
      <el-table-column
        prop="systemTransactionId"
        header-align="center"
        align="center"
        label="系统交易编号">
      </el-table-column>
      <el-table-column header-align="center" align="center" label="支付渠道">
        <template slot-scope="scope">
          {{ getLabelByValue(payChannelOptions, scope.row.payChannelId) }}
        </template>
      </el-table-column>
      <el-table-column prop="requestStr" label="请求参数" 
        header-align="center" align="center" 
        width="150" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="responseStr" label="响应字符串" 
        header-align="center" align="center" 
        width="150" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createDate"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        header-align="center"
        align="center"
        label="更新时间">
      </el-table-column>
       <el-table-column prop="remark" label="备注" 
        header-align="center" align="center" 
        width="150" :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
  </div>
</template>
<script>
  import mixinViewModule from "@/mixins/view-module";
  export default {
    mixins: [mixinViewModule],
    data () {
      return {
        dataForm: {
          accpTxno: '',
          txnSeqno: '',
          applyId: '',
          payChannelId: '',
          status: '',
          createStart: '',
          createEnd: '',
        },
         // 支付渠道
        payChannelOptions: [
          { label: '连连支付', value: 0 },
          { label: '统统付', value: 1 }
        ],
        // 提现状态选项数组
        statusOptions: [
          { label: '提现失败', value: 0 },
          { label: '申请提现', value: 1 },
          { label: '提现成功', value: 2 }
        ],
        date: null,
        mixinViewModuleOptions: {
          getDataListURL: "/api/withdrawal-record/page",
          getDataListIsPage: true
        },
      }
    },
    components: {
    
    },
    activated () {
      this.getDataList()
    },
    methods: {
     getTimes() {
        if (this.date != null) {
          this.dataForm.createStart = this.date[0]
          this.dataForm.createEnd = this.date[1]
          console.log(33,this.dataForm);
        } else{
          delete this.dataForm.createStart
          delete this.dataForm.createEnd
        }
     },
     getLabelByValue(options, value) {
        const item = options.find(option => option.value === value);
        return item ? item.label : value;
     }
    }
  }
</script>
